/** Appendix A 7.10 licence jurisdictions (mirrors the backend enum). */
export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC', 'AS', 'GU', 'MP', 'PR', 'VI',
] as const;
export const CA_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'] as const;
export const JURISDICTIONS = [...US_STATES, ...CA_PROVINCES] as const;
export type Jurisdiction = (typeof JURISDICTIONS)[number];

/** Backend normalization for CDL numbers (7.11): uppercase, keep A-Z/0-9 only. */
export function normalizeCdl(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
}
